import config from "@config/index";

export const Constants = {
  GARTNER_DOMAIN: "gartner.com",
  LOGO_ALT_TEXT: "Gartner Logo",
  HOMEPAGE: "Datahub HomePage",
  API: {
    API_PATH: config.API_PATH,
  },

  ROUTES: {
    BASE_URL: "/data-hub",
    DASHBOARD: "/dashboard",
    SAVE: "/my-library",
    EXPLORE: "/report-list-view",
    LANDINGPAGE: "/",
    MOBILE: "/mobile",
    MYLIBRARY:'/my-library',

  },
  HEADER: {
    SECONDARY_LOGO_LABEL: "DataHub",
    SECONDARY_LOGO_VERSION: "BETA",
    SIGN_OUT: "Sign Out",
    CLASSNAME: "delphi-header-wrapper",
    SEARCH_LABEL: "Search",
    GARTNER_LABEL: "Gartner.com",
    PROFILE: "Profile",
    LIBRARY: "Library",
    HOSTNAME_DEV: "toolsdv.gartner.com",
    HOSTNAME_QA: "toolsqa.gartner.com",
    GCOM_REDIRECTION_DEV: "https://gcom.pdodev.aws.gartner.com/en",
    GCOM_REDIRECTION_QA: "https://gcom.pdoqa.aws.gartner.com/en"
  },
  LABELS: {
    DATAHUB_DASHBOARD: "datahub_dashboard",
  },
  ACTIS: {
    KEY_INFO: "delphi-firehose",
    EVENT_DATA: {
      PAGE_LOAD: {
        activityAction: "Application_Login",
        activityMeta: "User logged into the application",
        activityValue: "true",
      },
      NAV_MENU_CLICK: {
        activityMeta: "User clicked on account icon from header",
        activityAction: "Account_Icon",
        activityValue: "true",
      },
      LOGOUT: {
        activityMeta: "User clicked on sign out from account menu",
        activityAction: "Sign_Out",
        activityValue: "true",
      },
      SECONDARY_LOGO: {
        activityMeta: "User clicked on Delphi logo from header",
        activityAction: "Delphi_Logo",
        activityValue: "true",
      },
      PRIMARY_LOGO: {
        activityMeta: "User clicked on Gartner Home logo from header",
        activityAction: "Gartner_Logo",
        activityValue: "true",
      },
      INTERCOM_HELP: {
        activityMeta: 'User clicks on the Intercom Help link',
        activityAction: 'Intercom_Help_Click',
        activityValue: 'TRUE',
      },
      SEARCH_METRIC: {
        activityAction: "Search_Metric",
        activityMeta: "User entered value on Search bar",
      }
    },
    APP_LAUNCHER: {
      LABELS: {
        APP_LAUNCHER_EXPANDED: "###PAGE_NAME### | App Launcher Expanded",
        APP_LAUNCHER_COLLAPSED: "###PAGE_NAME### | App Launcher Collapsed",
        APP_LAUNCHER_TOOL_CLICKED:
          "###PAGE_NAME### | ###TOOL_NAME### | Tool launched from App Launcher",
        APP_LAUNCHER_SEE_ALL_TOOLS: "###PAGE_NAME### | See All Tools",
      },
      ACTIONS: {
        APP_LAUNCHER_EXPANDED:
          "User clicked on the App Launcher Icon to expand the menu",
        APP_LAUNCHER_COLLAPSED:
          "User clicked on the App Launcher Icon to collapse the menu",
        APP_LAUNCHER_TOOL_CLICKED: "User launched a tool from the App Launcher",
        APP_LAUNCHER_SEE_ALL_TOOLS:
          "User clicked See All Tools from the App Launcher menu",
      },
      COMMON_PLACEHOLDERS: {
        ROLE: '###ROLE###',
        PAGE_NAME: '###PAGE_NAME###',
        TOOL_NAME: '###TOOL_NAME###',
      }
    },
  },
  ERROR_CODE: {
    UNAUTHORIZED: 403,
  },
  INTERCOM: {
    HELP: 'Help',
    LOGOUT: "logout",
  },
  GARTNER_URL: "https://www.gartner.com/en",
  ACCESS_DENIED: "access-denied",
  VERTICAL_NAV_LABELS: {
    Home: "Home",
    Dashboard: "Dashboard",
    Library: "Saved Library",
    Explore: "Explore",
    Playground: "Metrics Analyzer",
  },
  VALID_ROUTES: ["/ppt-viewer", "/reports", "/report", "/in-progress", "/my-library", "/dashboard", "/report-list-view", "/use-cases", "/cma"],
};
